import React from "react";

import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import ProductsTableFilters from "components/subComponents/ProductsTableFilters";

import useProductsList from "hooks/list/useProductsList";

function ElencoProdotti() {
    const productsListHook = useProductsList();

    const { navigateToNewProduct, alertConfirmHook, dataTableHook } = productsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <ProductsTableFilters productsListHook={productsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewProduct}>
                        Aggiungi Prodotto
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoProdotti;
